import SunshineCard from '../../../../../../../../components/_core/SunshineCard';
import SquircleIcon from '../../../../../../../../components/_core/SunshineSquircleIcon';
import getRoleLabel from '../../helpers/getRoleLabel/getRoleLabel';
import locales from './locales';

interface BeneficiaryCardProps {
  beneficiary: {
    firstName?: string | null;
    lastName?: string | null;
    isDirector?: boolean | null;
    isMajorShareholder?: boolean | null;
  };
  isCurrentUser?: boolean;
  onClick?: () => void;
  invalid?: boolean;
}

const BeneficiaryCard = ({
  beneficiary,
  invalid = false,
  isCurrentUser,
  onClick,
}: BeneficiaryCardProps) => {
  const {
    firstName = '',
    isDirector = false,
    isMajorShareholder = false,
    lastName = '',
  } = beneficiary;
  const fullName = `${firstName} ${lastName}`;

  return (
    <SunshineCard onClick={onClick}>
      {invalid ? (
        <SunshineCard.Slot name="aside">
          <SquircleIcon
            colorScheme="orange"
            iconColor="orange.800"
            margin="auto"
            name="warning"
          />
        </SunshineCard.Slot>
      ) : null}
      <SunshineCard.Content>
        <SunshineCard.Text fontWeight="weight-500" size="md" variant="primary">
          {isCurrentUser
            ? locales.formatString(locales.currentUserTitle, { fullName })
            : fullName}
        </SunshineCard.Text>
        <SunshineCard.Text color={invalid ? 'orange.800' : 'inherit'}>
          {getRoleLabel({
            invalid,
            isDirector,
            isMajorShareholder,
          })}
        </SunshineCard.Text>
      </SunshineCard.Content>

      {onClick ? (
        <SunshineCard.Slot name="action">
          <SunshineCard.SunshineIcon name="chevron-right" />
        </SunshineCard.Slot>
      ) : null}
    </SunshineCard>
  );
};

export default BeneficiaryCard;
